import ImageMedia from './ImageMedia';

export default ImageMedia;
